export const ErrorMessage = [
    { code: 0, msg: "成功", enmsg: "Success" },

    { code: 10000, msg: "參數無效", enmsg: "Parameter is invalid" },
    { code: 10001, msg: "未知錯誤", enmsg: "Unknown error" },
    { code: 10002, msg: "服務不可用", enmsg: "Service unavailable" },
    { code: 10003, msg: "登入票據已過期", enmsg: "Access token expired" },
    { code: 10004, msg: "App客戶端票據無效", enmsg: "App client secret invalid" },
    { code: 10005, msg: "密碼不正確！\n還有{RemainingTime}次嘗試機會，如果3次嘗試失敗，賬戶會被鎖30分鐘。", enmsg: "Wrong password!\n{RemainingTime}trial(s) remaining.The account will locked for 30mins if reach 3 failures." },
    { code: 10006, msg: "會員狀態無效", enmsg: "Member status invalid" },
    { code: 10007, msg: "用戶狀態無效", enmsg: "User status invalid" },
    { code: 10008, msg: "中心狀態無效", enmsg: "Centre status invalid" },
    { code: 10009, msg: "機構狀態無效", enmsg: "Ngo status invalid" },
    { code: 10010, msg: "供应商狀態無效", enmsg: "Vendor status invalid" },
    { code: 10011, msg: "设备狀態無效", enmsg: "Equipment status invalid" },
    { code: 10012, msg: "用戶的refresh-token已過期", enmsg: "User's refresh-token expired" },
    { code: 10013, msg: "無權限訪問", enmsg: "Permission denied" },

    { code: 20017, msg: "驗證連接已經過期", enmsg: "Cuser email verify link is expires" },
    { code: 20018, msg: "驗證連接已經被使用", enmsg: "Cuser email verify link is used" },
    { code: 20019, msg: "非法的連接", enmsg: "Cuser email verify link is invalid" },
    { code: 20020, msg: "賬戶新密碼不能與舊密碼一樣", enmsg: "User's new password cannot be the same as the old password" },

    { code: 30000, msg: "用戶無權限操作", enmsg: "User does not have permission to operate" },
    { code: 30001, msg: "培训教材不存在", enmsg: "Training material does not exists" },
    { code: 30002, msg: "沒有登入權限", enmsg: "User permission does not exist" },
    { code: 30003, msg: "用戶角色不存在", enmsg: "User role does not exist" },
    { code: 30004, msg: "用戶不存在", enmsg: "User does not exist" },
    { code: 30005, msg: "會員不存在", enmsg: "Member does not exist" },
    { code: 30006, msg: "中心用戶不存在", enmsg: "Centre user does not exist" },
    { code: 30007, msg: "中心不存在", enmsg: "Centre does not exist" },
    { code: 30008, msg: "機構不存在", enmsg: "Ngo does not exist" },
    { code: 30009, msg: "供應商不存在", enmsg: "Vendor does not exist" },
    { code: 30010, msg: "設備不存在", enmsg: "Equipment does not exist" },
    { code: 30011, msg: "會員已經存在", enmsg: "Member has already existed" },
    { code: 30012, msg: "中心用戶已經存在", enmsg: "Centre user has already existed" },
    { code: 30013, msg: "中心已經存在", enmsg: "Centre has already existed" },
    { code: 30014, msg: "機構已經存在", enmsg: "Ngo has already existed" },
    { code: 30015, msg: "供應商已經存在", enmsg: "Vendor has already existed" },
    { code: 30016, msg: "设备已經存在", enmsg: "Equipment has already existed" },
    { code: 30017, msg: "中心電郵已經存在", enmsg: "Centre email has already existed" },
    { code: 30018, msg: "不允許交叉中心", enmsg: "Cross centers are not allowed" },
    { code: 30019, msg: "無法從token獲取用戶的中心資訊", enmsg: "Unable to obtain user's centre information from token" },
    { code: 30020, msg: "無法從token獲取用戶的機构資訊", enmsg: "Unable to obtain user's ngo information from token" },
    { code: 30021, msg: "培訓教程已經存在", enmsg: "Training material has already existed" },
    { code: 30022, msg: "無法獲取當前機构/中心的會員信息", enmsg: "Unable to obtain membership information for current organization/center" },
    { code: 30023, msg: "無法保存圖片", enmsg: "Unable to save pictures" },
    { code: 30024, msg: "假期已經存在", enmsg: "Public holidays has already existed" },
    { code: 30025, msg: "假期不存在", enmsg: "Public holidays does not exist" },
    { code: 30026, msg: "用戶角色代碼已經存在", enmsg: "User role code has already existed" },
    { code: 30027, msg: "當前角色組下有活躍用戶", enmsg: "Active users exist in the current role group" },
    { code: 30028, msg: "設備代碼已經存在", enmsg: "Device code has already existed" },
    { code: 30029, msg: "數據集號碼已經存在", enmsg: "Data set code has already existed" },
    { code: 30030, msg: "數據集不存在", enmsg: "Data set does not exist" },
    { code: 30031, msg: "數據號碼已經存在", enmsg: "Data schema code has already existed" },
    { code: 30032, msg: "數據名稱已經存在", enmsg: "Data schema name has already existed" },
    { code: 30033, msg: "數據排序已經存在", enmsg: "Data schema Sort has already existed" },
    { code: 30034, msg: "數據不存在", enmsg: "Data schema does not exist" },
    { code: 31000, msg: "類別不存在", enmsg: "Type does not exist" },
    { code: 31001, msg: "類別代碼已經存在", enmsg: "Type code has already existed" },
    { code: 31002, msg: "上級類別不存在", enmsg: "Type parent does not exist" },
    { code: 31003, msg: "請給予正確的可使用部分", enmsg: "Please give correct usable parts" },
    { code: 31004, msg: "健康類別名稱已經存在", enmsg: "Health type name has already existed" },
    { code: 31005, msg: "健康類別父節點不可使用", enmsg: "Health type parent does not enable" },
    { code: 31006, msg: "機構號碼已經存在", enmsg: "Ngo code has already existed" },
    { code: 31007, msg: "機構名稱（英文）已經存在", enmsg: "Ngo name (english) has already existed" },
    { code: 31008, msg: "機構名稱（中文）已經存在", enmsg: "Ngo name (chinese) has already existed" },
    { code: 31009, msg: "中心號碼已經存在", enmsg: "Centre code has already existed" },
    { code: 31010, msg: "中心名稱（英文）已經存在", enmsg: "Centre name (English) has already existed" },
    { code: 31011, msg: "中心名稱（中文）已經存在", enmsg: "Centre name (Chinese) has already existed" },
    { code: 31012, msg: "當前機构下麵有中心數據", enmsg: "The current ngo has central data under it" },
    { code: 31013, msg: "當前中心下麵有會員數據", enmsg: "The current centre has member data under it" },

    { code: 40001, msg: "會員沒有尚未完成的調查", enmsg: "Member has no uncompleted survey" },
    { code: 40002, msg: "同意書沒有簽署", enmsg: "Consent has not signed" },
    { code: 40003, msg: "協議沒有簽署", enmsg: "Agreement has not signed" },
    { code: 40004, msg: "同意書已經簽署", enmsg: "Consent has already signed" },
    { code: 40005, msg: "協議已經簽署", enmsg: "Agreement has already signed" },
    { code: 40006, msg: "請選擇必填項", enmsg: "The answer list is empty" },
    { code: 40007, msg: "分數列表是空的", enmsg: "The score list is empty" },
    { code: 40008, msg: "調查問卷已完成", enmsg: "Survey has already completed" },
    { code: 40009, msg: "'是否同意記錄和計劃'不能爲空", enmsg: "Agreed record and plan fields are missing" },
    { code: 40010, msg: "簽名不能爲空", enmsg: "Miss signature base 64 parameter" },
    { code: 40011, msg: "同意書或協議是重複的", enmsg: "Consent or agreement has already existed" },
    { code: 40012, msg: "還沒到做問卷的時間", enmsg: "Survey available time has not reached" },
    { code: 40013, msg: "保存簽名失敗", enmsg: "Save signature failed" },

    { code: 50001, msg: "事件類型無效", enmsg: "Event type is invalid" },
    { code: 50002, msg: "事件類型已經存在", enmsg: "Event facility type has already existed" },
    { code: 50003, msg: "保存海報失敗", enmsg: "Save poster failed" },
    { code: 50004, msg: "事件不存在", enmsg: "Event is not found" },
    { code: 50005, msg: "類型不可編輯", enmsg: "No Editable Type" },
    { code: 50006, msg: "更新類型失敗", enmsg: "Update type failed" },
    { code: 50007, msg: "不可重複登記活動", enmsg: "Event enrolment has already existed" },
    { code: 50008, msg: "沒有登記活動記錄", enmsg: "No event enrolment record" },
    { code: 50009, msg: "沒有活動入場記錄", enmsg: "No event checkin record" },
    { code: 50010, msg: "沒有活動離場記錄", enmsg: "No event checkout record" },
    { code: 50011, msg: "已超出活動登記時間", enmsg: "Event registration time has expired" },
    { code: 50012, msg: "已過期無法離場", enmsg: "Expired already can't checked out" },
    { code: 50013, msg: "不能取消登記已入場/離場的活動", enmsg: "Unenroll linked record does not available" },
    { code: 50014, msg: "會員已經離場", enmsg: "Member has already checked out" },
    { code: 50015, msg: "活動的結束時間必須大於開始時間", enmsg: "The event end time must be greater than the event start time" },
    { code: 50016, msg: "單次活動不能設定多個活動時間和地點", enmsg: "Single event can not have multiple venues and time" },
    { code: 50017, msg: "缺少活動時間和地點", enmsg: "Lack of event time and place" },
    { code: 50018, msg: "非活躍用戶不能報名", enmsg: "Withdrew member cannot enroll" },
    { code: 50019, msg: "非活躍用戶不能入場登記", enmsg: "Withdrew member cannot check-in" },
    { code: 50020, msg: "非活躍用戶不能離場登記", enmsg: "Withdrew member cannot check-out" },
    { code: 413, msg: "上載文件超過限制", enmsg: "Upload files over the limit" },

    { code: 60000, msg: "賬戶已被鎖，請於30分鐘後再試。", enmsg: "You account have been locked for 30mins,please come back later." },
    { code: 60001, msg: "會員賬號不存在", enmsg: "Member accout does not exist" },
    { code: 60002, msg: "一次性密碼無效", enmsg: "The One-time password invalid" },
    { code: 60003, msg: "一次性密碼已經被使用", enmsg: "The One-time password have been used" },
    { code: 60004, msg: "一次性密碼已經過期", enmsg: "The one-time password has expired" },
    { code: 60005, msg: "賬戶已被鎖，請於30分鐘後再試。", enmsg: "You account have been locked for 30mins,please come back later. " },
    { code: 60006, msg: "您的密碼已過期，請立即去更新密碼", enmsg: "Your password has expired,please update it immediately" },
    { code: 60007, msg: "您的密碼已過期，請立即去更新密碼", enmsg: "Your password has expired,please update it immediately" },
    { code: 60008, msg: "啓動賬戶失敗", enmsg: "Start member accout failed" },
    { code: 60009, msg: "賬戶未激活", enmsg: "The Member accout is not active" },
    { code: 60010, msg: "來自一次性密碼登入", enmsg: "From one-time password login" },
]


